// Shared endpoint labels for desktop, mobile and coach forms.
const EN = {
  "Stämmer inte alls": "Not true at all",
  "Inte ont": "No pain", "Mycket ont": "A lot of pain",
  "Inte trött": "Not tired", "Mycket trött": "Very tired",
  "Inte alls": "Not at all",
  "Mycket": "Very much",
  "Mycket dåligt": "Very poor",
  "Mycket bra": "Very good",
  "I mycket hög grad": "To a very high degree",
  "Stämmer inte ännu": "Not true yet",
  "Stämmer helt": "Fully true",
  "Inte alls trygg": "Not at all safe",
  "Mycket trygg": "Very safe"
};
export function localizedScaleLabels(labels, language = 'sv', definitionSource) {
  if (!labels) return null;
  // Frozen anchors are already localized from the recorded definition.
  if (definitionSource === 'frozen') return { left: labels.left || '', right: labels.right || '' };
  const english = String(language).toLowerCase().startsWith('en');
  return { left: english ? (EN[labels.left] || labels.left || '') : (labels.left || ''),
           right: english ? (EN[labels.right] || labels.right || '') : (labels.right || '') };
}
